<template>
<div class="payment-page">
	<div class="payment-inner">
		<button type="button" class="back-btn" @click="goBack">
			<i class="el-icon-arrow-left"></i>
			<span>{{ $t('Back') }}</span>
		</button>

		<div class="order-card">
			<h2 class="order-card__title">{{ memberInfo.order_title }}</h2>
			<p class="order-card__desc" v-if="orderDesc">{{ orderDesc }}</p>
			<div class="order-card__price">{{ displayPrice(memberInfo.order_price) }}</div>
		</div>

		<div class="pay-section">
			<div class="pay-section__label">
				<span class="dot"></span>
				<span>{{ $t('Payment Method') }}</span>
			</div>
			<div class="pay">
				<div class="pay-item">
					<el-radio v-model="form.pay_method" :label="1">{{ $t('Credit Card') }}</el-radio>
					<img src="../assets/img/Visa.png" alt="" />
					<img src="../assets/img/Mastercard.png" alt="" />
					<img src="../assets/img/American Express.png" alt="" />
					<img src="../assets/img/Discover.png" alt="" />
				</div>
				<Dropin :token="token" v-if="token"/>
			</div>
		</div>

		<div class="page-center" v-if="memberInfo.commission_is_show">
			<div>
				<p>{{ $t('Price') }}:</p>
				<span>{{ displayPrice(memberInfo.show_order_price) }}</span>
			</div>
			<div>
				<p>{{ $t('Processing Fee (3%)') }}:</p>
				<span>{{ displayPrice(memberInfo.commission_price) }}</span>
			</div>
		</div>

		<div class="checkout">
			<div class="checkout__total">
				<span class="checkout__total-label">{{ $t('Payment amount') }}</span>
				<strong class="checkout__total-price">{{ displayPrice(memberInfo.order_price) }}</strong>
			</div>

			<label class="checkout__agree">
				<el-checkbox v-model="agreed"></el-checkbox>
				<span class="agree-text">
					{{ $t('I agree to the') }}
					<a href="/goods/service" target="_blank">{{ $t('User Service Agreement') }}</a>
				</span>
			</label>

			<button
				type="button"
				class="checkout__btn"
				:class="{ isDisabled: token || isDistable || !agreed }"
				:disabled="!!token || isDistable || !agreed"
				@click="buyNow"
			>
				{{ $t('Buy Now') }}
			</button>
		</div>
	</div>
</div>
</template>
<script src="https://js.braintreegateway.com/web/dropin/1.36.0/js/dropin.min.js"></script>
<script>
	import { buyMember, buyCredit, confirmOrder, stripePayment, recordClick } from '../api';
	import { loadingData } from '../utils';
	import { getUser, setUser } from '../store/user';
	import Dropin from '@/components/Dropin.vue'
	import { keys, setStore } from '../store';

	export default {
		components: { Dropin },
		name: 'Paymenthly',
		data() {
			return {
				memberInfo: {},
				form: {
					pay_method: 1,
					username: '',
					email: '',
					mobile: '',
					order_no: '',
				},
        token:'',
        isDistable:false,
				agreed: false,
			};
		},
		computed: {
			orderDesc() {
				const details = this.memberInfo.order_details;
				if (Array.isArray(details) && details.length) {
					return details.filter(Boolean).join(' ');
				}
				if (typeof details === 'string' && details) return details;
				return this.memberInfo.order_price_name || '';
			},
		},
		async mounted() {
			let { id, type, token } = this.$route.query;
      if(token){
        setStore(keys.token, token)
        setStore(keys.lang, "zh_CN")
        setUser()
      }
			await loadingData(async () => {
				this.memberInfo = await (type === 'member' ? buyMember(id) : buyCredit(id));
				this.form.order_no = this.memberInfo.order_no;
			});
      if(!token){
        let user = getUser();
        let { name, email, mobile, country_code, user_sn } = user.user_info;
        this.form.username = name;
        this.form.email = email;
        this.form.mobile = `+${country_code} ${mobile}`;
        await recordClick(6,user_sn,'product-name:'+this.memberInfo.order_title);
      }
		},
		methods: {
			displayPrice(val) {
				if (val == null || val === '') return '';
				return String(val)
					.replace(/¥|￥|CNY|RMB/gi, '$')
					.replace(/＄/g, '$');
			},
			goBack() {
				history.back();
			},
			async buyNow() {
        if(this.isDistable || this.token) return
				if (!this.agreed) {
					this.$message.warning(this.$t('Please agree to the service agreement'));
					return;
				}
        this.isDistable = true
				await loadingData(async () => {
          await confirmOrder(this.form);
          let result = await stripePayment(this.form.order_no, 'pricing');
          location.href = result.url;
        });
      }
    },
	}
</script>

<style lang="less" scoped>
.payment-page {
	min-height: calc(100vh - 110px);
	background: #f7f7f7;
	padding: 32px 16px 64px;
	box-sizing: border-box;
}

.payment-inner {
	width: 100%;
	max-width: 720px;
	margin: 0 auto;
}

.back-btn {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	height: 32px;
	padding: 0 12px;
	border: none;
	border-radius: 4px;
	background: #B50604;
	color: #fff;
	font-size: 0.875rem;
	font-family: inherit;
	cursor: pointer;
	line-height: 1;
	transition: opacity 0.15s ease;

	i {
		font-size: 0.875rem;
	}

	&:hover {
		opacity: 0.9;
	}
}

.order-card {
	margin-top: 20px;
	padding: 28px 32px;
	background: #fff;
	border: 1px solid #eee;
	border-radius: 4px;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}

.order-card__title {
	margin: 0;
	font-size: 1.5rem;
	font-weight: 700;
	line-height: 1.4;
	color: #111;
}

.order-card__desc {
	margin: 10px 0 0;
	font-size: 0.9375rem;
	line-height: 1.5;
	color: #888;
}

.order-card__price {
	margin-top: 20px;
	font-size: 1.75rem;
	font-weight: 700;
	line-height: 1.2;
	color: #B50604;
}

.pay-section {
	margin-top: 28px;
	padding: 0 4px;
}

.pay-section__label {
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 1rem;
	font-weight: 600;
	color: #222;
	margin-bottom: 16px;

	.dot {
		width: 6px;
		height: 6px;
		border-radius: 50%;
		background: #B50604;
		flex-shrink: 0;
	}
}

.pay-item {
	display: flex;
	align-items: center;
	margin-top: 8px;

	img + img {
		margin-left: 10px;
	}

	img {
		cursor: pointer;
		height: 21px;
	}

	/deep/ .el-radio__label {
		font-size: 1rem;
		color: #000;
		padding-left: 8px;
	}

	/deep/ .el-radio__input.is-checked .el-radio__inner {
		border-color: #B50604 !important;
		background-color: #B50604 !important;
	}

	/deep/ .el-radio__input.is-checked + .el-radio__label {
		color: #B50604 !important;
	}
}

.page-center {
	margin-top: 24px;
	padding: 16px 4px 0;
	border-top: 1px solid #e6e6e6;

	div {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 8px;
	}

	p,
	span {
		margin: 0;
		font-size: 0.9375rem;
		color: #333;
	}

	span {
		font-weight: 600;
	}
}

.checkout {
	margin-top: 28px;
	padding-top: 24px;
	border-top: 1px solid #e6e6e6;
}

.checkout__total {
	display: flex;
	align-items: baseline;
	gap: 12px;
	flex-wrap: wrap;
}

.checkout__total-label {
	font-size: 1rem;
	font-weight: 600;
	color: #222;
}

.checkout__total-price {
	font-size: 1.5rem;
	font-weight: 700;
	color: #B50604;
	line-height: 1.2;
}

.checkout__agree {
	display: flex;
	align-items: center;
	gap: 8px;
	margin-top: 18px;
	cursor: pointer;
	user-select: none;

	.agree-text {
		font-size: 0.875rem;
		color: #333;
		line-height: 1.4;
	}

	a {
		color: #B50604;
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}

	/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
	/deep/ .el-checkbox__input.is-focus .el-checkbox__inner {
		background-color: #B50604;
		border-color: #B50604;
	}

	/deep/ .el-checkbox__inner:hover {
		border-color: #B50604;
	}

	/deep/ .el-checkbox__label {
		display: none;
	}
}

.checkout__btn {
	display: block;
	width: 240px;
	height: 40px;
	margin-top: 20px;
	border: none;
	border-radius: 4px;
	background: #B50604;
	color: #fff;
	font-size: 1rem;
	font-weight: 600;
	font-family: inherit;
	cursor: pointer;
	line-height: 40px;
	text-align: center;
	padding: 0;
	transition: opacity 0.15s ease;

	&:hover:not(.isDisabled) {
		opacity: 0.92;
	}

	&.isDisabled {
		cursor: not-allowed;
		background: #ccc;
		color: #fff;
	}
}

@media screen and (max-width: @device) {
	.payment-page {
		padding: 20px 12px 48px;
	}

	.order-card {
		padding: 20px 16px;
	}

	.order-card__title {
		font-size: 1.25rem;
	}

	.order-card__price {
		font-size: 1.5rem;
	}

	.checkout__btn {
		width: 100%;
		max-width: 240px;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/Paymenthly.vue